import React, { useCallback, useRef, useState } from "react";

import AppTemplate from "../../component/app-template";
import { Styles } from "./styles";
import { QrReader } from "react-qr-reader";
import axios from "axios";

const QRScannerPage = () => {
  const [data, setData] = useState("لا توجد نتيجة");
  const [isScanning, setIsScanning] = useState(false);
  const [manualName, setManualName] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("idle");
  const [submitting, setSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successName, setSuccessName] = useState("");
  const submittingRef = useRef(false);

  const submitAttendance = useCallback(async (name) => {
    const trimmedName = name?.trim();
    if (!trimmedName) {
      setStatusType("error");
      setStatusMessage("الاسم مطلوب لإتمام تسجيل الحضور.");
      return false;
    }

    setSubmitting(true);
    submittingRef.current = true;
    setStatusType("info");
    setStatusMessage("جاري إرسال بيانات الحضور...");
    try {
      await axios.post(
        "https://zczduwvikuodiuosrjye.supabase.co/functions/v1/attendance-register",
        {
          eventId: 1,
          name: trimmedName,
          mobileNumber: "0938876680",
        }
      );
      setStatusType("success");
      setStatusMessage("تم تسجيل الحضور بنجاح.");
      setSuccessName(trimmedName);
      setShowSuccessModal(true);
      return true;
    } catch (error) {
      setStatusType("error");
      setStatusMessage("تعذّر إرسال الحضور، يرجى المحاولة مرة أخرى.");
      console.error("Attendance submit error", error);
      return false;
    } finally {
      setSubmitting(false);
      submittingRef.current = false;
    }
  }, []);

  const handleManualSubmit = async (event) => {
    event.preventDefault();
    const wasSuccessful = await submitAttendance(manualName);
    if (wasSuccessful) {
      setManualName("");
    }
  };

  const handleScanResult = async (result) => {
    if (submittingRef.current) return;

    const scannedText = result?.text?.trim();
    if (!scannedText) return;

    setIsScanning(false);
    await submitAttendance(scannedText);
    setData(scannedText);
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
  };

  return (
    <AppTemplate
      pageTitle="qrScannerPage.title"
      navbar={true}
      footer={true}
      footerBackgroundColor="var(--main-color-darker)"
    >
      <Styles>
        <div className="scanner-card">
          <div className="hero-copy">
            <h3>تسجيل الدخول الفوري</h3>
            <p className="subtext">
              امسح شارات الحضور أو سجّل يدويًا خلال ثوانٍ معدودة.
            </p>
          </div>

          <div className="scan-trigger">
            <button
              type="button"
              className="scan-button"
              onClick={() => setIsScanning((prev) => !prev)}
              disabled={submitting}
            >
              {isScanning ? "إيقاف المسح" : "ابدأ المسح"}
            </button>
            <span>ضع رمز QR داخل الإطار لالتقاطه.</span>
          </div>

          {isScanning && (
            <div className="qr-wrapper">
              <QrReader
                onResult={(result, error) => {
                  if (!!result) {
                    handleScanResult(result);
                  }

                  if (!!error) {
                    console.error("QR Scan error", error);
                  }
                }}
                constraints={{ facingMode: "environment" }}
                style={{ width: "100%", height: "320px" }}
              />
            </div>
          )}

          {/* <div className="result-pill">
            <span>آخر نتيجة</span>
            <p>{data}</p>
          </div> */}

          {!!statusMessage && (
            <p className={`status-message ${statusType}`}>{statusMessage}</p>
          )}

          <form className="manual-form" onSubmit={handleManualSubmit}>
            <label htmlFor="manual-name-input">التسجيل اليدوي</label>
            <div className="input-row">
              <input
                id="manual-name-input"
                type="text"
                value={manualName}
                onChange={(event) => setManualName(event.target.value)}
                placeholder="أدخل اسم أو رقم المشارك"
                disabled={submitting}
              />
              <button type="submit" disabled={submitting}>
                إرسال
              </button>
            </div>
          </form>
        </div>

        {submitting && (
          <div className="spinner-overlay">
            <div className="spinner" />
            <p>جاري تسجيل المشارك...</p>
          </div>
        )}

        {showSuccessModal && (
          <div className="modal-overlay" onClick={handleModalClose}>
            <div
              className="modal-content"
              onClick={(event) => event.stopPropagation()}
            >
              <h3>تم التسجيل</h3>
              <p>
                <strong>{successName}</strong> تم تسجيله بنجاح.
              </p>
              <button type="button" onClick={handleModalClose}>
                إغلاق
              </button>
            </div>
          </div>
        )}
      </Styles>
    </AppTemplate>
  );
};

export default QRScannerPage;
